import React from "react";
import Theme from '../../../theme.module.css';
import Style from './MicroserviceCommerce.module.css';
import CallToAction from "../../callToAction/CallToAction";

export default function MicroserviceCommerce({setModalOpen}) {

    return (
        <div>
            <div className={`${Theme.columns} animateColumns`}>
                <div style={{textAlign: "center"}} className={Style.glowBackground}>
                    <img src={require('../../../assets/microservice-icon.svg').default} alt="microservice-icon" className={Style.microserviceIcon} />
                </div>
                <div className={Theme.textCont}>
                    <p>85% of enterprise businesses use microservice architectures, to meet their requirements in terms of performance, scalability and agility.</p>
                    <br/>
                    <p>In order to reduce cost and time to delivery for our clients, we are developing our own in house ecommerce microservice core solution. It's the foundation to what will become your business's holistic digital commerce system (owned by you), tailored to any business requirement.</p>
                </div>
            </div>
            <div className="animateCallToAction">
                <CallToAction text="Get in touch to discuss our microservice commerce solution" setModalOpen={setModalOpen} />
            </div>
        </div>
    );
}